export type FulfillmentOrderSource = {
	externalShopifyOrderId?: string | null,
	lineItems: {
		demandRequestLineItem?: {
			demandRequest?: {
				requestNumber?: number | string | null,
			} | null,
		} | null,
	}[],
}

/**
 * Resolves the human-readable source a FulfillmentOrder originated from.
 * Shopify-sourced orders show "Shopify Order #12345"; otherwise we fall back to
 * the originating demand request's number as "REQ-12345".
 */
export default function getFulfillmentOrderSource( order: FulfillmentOrderSource ): string | null {
	if ( order.externalShopifyOrderId ) {
		return `Shopify Order #${order.externalShopifyOrderId}`
	}

	const requestNumber = order.lineItems
		.map( ( lineItem ) => lineItem.demandRequestLineItem?.demandRequest?.requestNumber )
		.find( ( number ) => number !== null && number !== undefined )

	return requestNumber !== null && requestNumber !== undefined ? `REQ-${requestNumber}` : null
}
